import React from "react";
import { IconButton } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { useStyles, ActionButton } from "./styles";

export interface IListTableSelect {
    isOpen: boolean;
    onCloseClick: () => void;
    selectedIds: string[];
    actionHandlers: IListTableHandlers[];
}

export interface IListTableHandlers {
    label: string;
    handler: (any) => void;
    dataTest: string;
}

export const ListTableSelect: React.FC<IListTableSelect> = ({
    isOpen,
    onCloseClick,
    selectedIds = [],
    actionHandlers,
}) => {
    const classes = useStyles();

    const actions = React.useMemo(() => {
        return (
            <div className="actionButtons">
                {actionHandlers.map((actionHandler, index) => (
                    <ActionButton
                        data-test={actionHandler.dataTest}
                        key={`${actionHandler.label}${index}`}
                        onClick={() => {
                            actionHandler.handler(selectedIds);
                        }}
                    >
                        {actionHandler.label}
                    </ActionButton>
                ))}
            </div>
        );
    }, [selectedIds, actionHandlers]);

    if (selectedIds.length == 0 || !isOpen) {
        return <div />;
    }

    return (
        <div className={classes.selectBox}>
            <div className="counter">{selectedIds.length}</div>
            <span className="itemsSelected">Items Selected</span>
            <div className="buttonGroup">
                {actions}
                <div>
                    <IconButton onClick={onCloseClick} aria-label="delete">
                        <Close />
                    </IconButton>
                </div>
            </div>
        </div>
    );
};
